import React from 'react';
import FollowMultipleEntitiesButton from './FollowMultipleEntitiesButton';
import FollowEntityButton from './FollowEntityButton';

const FollowButtonHandler = ({ multiple, ...props }) => {
  return multiple ? <FollowMultipleEntitiesButton {...props} /> : <FollowEntityButton {...props} />;
};

export default FollowButtonHandler;
